import { get, post } from '../util/axios';

export default {
  list: async () => {
    const url = '/api/rss/list';
    return await get(url);
  },
  modify: async (rss) => {
    const url = '/api/rss/' + (rss.id ? 'modify' : 'add');
    return await post(url, rss);
  },
  delete: async (id) => {
    const url = '/api/rss/delete';
    return await post(url, { id });
  },
  delRecord: async (body) => {
    const url = '/api/rss/deleteRecord';
    return await post(url, body);
  },
  dryrun: async (rss) => {
    const url = '/api/rss/dryrun';
    return await post(url, rss);
  },
  dryrunRule: async (body) => {
    const url = '/api/rss/dryrunRule';
    return await post(url, body);
  },
  scrapeDryrun: async (rss) => {
    const url = '/api/rss/scrapeDryrun';
    return await post(url, rss);
  },
  promoSupport: async (hosts) => {
    const url = '/api/rss/promoSupport?host=' + encodeURIComponent(hosts.join(','));
    return await get(url);
  },
  scrapeTorrent: async (body) => {
    const url = '/api/rss/scrapeTorrent';
    return await post(url, body);
  },
  mikanSearch: async (rss) => {
    const url = '/api/rss/mikanSearch';
    return await post(url, rss);
  },
  mikanPush: async (body) => {
    const url = '/api/rss/mikanPush';
    return await post(url, body);
  },
  batchUpdate: async (body) => {
    const url = '/api/rss/batchUpdate';
    return await post(url, body);
  }
};
